module.exports = __webpack_public_path__ + "img/lv1.6197e858.png";